function setCookie(name, value, time) {
  var Days = time || 30
  var exp = new Date()
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
  document.cookie = name + '=' + escape(value || '') + ';expires=' + exp.toGMTString() + ';path=/'
}

function getCookie(name) {
  var arr
  var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  const result = (arr = document.cookie.match(reg)) ? unescape(arr[2]) : ''
  return decodeURIComponent(result)
}

function tip(){
  const po = u.ui.pop(`<div id=e1 class="e e1">任务添加成功，可在<w>[个人中心-时间管理]</w>查看哟～</div>`,
  `.mask { ps: re}
  .e1 { lh: 40; f: 14; bo: 8; m: a 20; ta: c; bgc: rgba(0, 0, 0, 0.6); c: white; ps: fixed; b: 64; l: 0; r: 0; }
  .e1 > w { c: #FFC226; }`, {init: e => {
    // e.n('#e1').h(`任务添加成功，可在<w>[个人中心-时间管理]</w>查看哟～`)
    setTimeout(e => po.hide(), u.tm.s * 2)
  }})
}

function pop(info) {
  const po = u.ui.pop(`<div id=f1 class="f f1">
      <div id="e0" class="e e0"></div>
      <div id="e1" class="e e1">
        <div id="i1" class="e i1">子衿帮你检索到学习任务【课后巩固】</div>
        <div id="i0" class="e i0" t=22569人>正在参与，你是否要加入？</div>
      </div>
      <div id="e2" class="i e2">+ 添加该任务</div>
      <div id="a0" class="a a0">×</div>
    </div>
  `, `.mask { ps: re}
  .f1 { w: 100%; h: 49; bgc: rgba(0, 0, 0, 0.6); ai: c; ps: fixed; b: 64; }
  .e0 { w: 36; h: 36; ml: 16; bo: 50%; bgi: url(/cms/static/images/logo-128.png) }
  .e1 { ml: 8; c: #FFFFFF; }
  .i1 { f: 13; }
  .i0 { f: 12; o: 0.8; }
  .i0::before { con: attr(t); c: #FFC226; }
  .e2 { w: 72; lh: 24; f: 10; c: white; m: a; ta: c; bgi: lg(90deg, #FD735D 0.16%, #FF423C 100.16%); bo: 50; }
  .e2::first-letter { con: '+'; f: 20; v: -3; }
  .a0 { w: 16; lh: 16; f: 16; c: #C5C5C5; ta: c; bo: 50%; bd: 1 s #C5C5C5; r: 0; t: -8; }
  .a0::before { w: 150%; h: 150%; con: ''; ps: ab; ml: -50%; mt: -50%; }
  .f1 * { pe: no; }
  .a0, .e2 { pe: a; }
  `, {init: e => {
    e.n('#i0').i('t', `${info.memberCt}人`)
    e.n('#i1').e(`子衿帮你检索到学习任务【${info.summary}】`)
    e.n('#a0').on('click', e => {e.stopPropagation(); po.hide()})
    e.n('#e2').on('click', async e => {
      e.stopPropagation()
      const appid = u.db.appid, openid = u.db.openid
      const code = info.code
      const r = await u.fet(`/mopa/api-internet-user/open/learningtask/save-by-code/${appid}/${openid}/${code}`)
      if (r.msg == "success" && r.status == 200) return tip()
      u.ui.tip(r.msg)
    })
    e.n('#f1').on('click', e => {u.go('/cms/webapp/home/todo/index.html#/edit?code=' + info.code)})
  }})
}

function mem(code, info) {
  const tt = getCookie('todo_tip')
  if (!tt) {
    pop(info)
    setCookie('todo_tip', [code].t(','), 1)
  }
  if (tt && !tt.t(',').i(code)) {
    pop(info)
    setCookie('todo_tip', tt.t(',').e(code).t(','), 1)
  }
}

async function chk(code, st) {
  const appid = u.db.appid, openid = u.db.openid

  const dt = await u.get(`/mopa/api-internet-user/open/learningtask/temp/list/${appid}`)
  const h = dt.data.n(i => i.code == code, 1)
  if (h == -1) return // no thus code return
  const info = dt.data[h]

  const d = await u.get(`/mopa/api-internet-user/open/weixinuser-learningtask/has-register/${appid}/${openid}`)
  if (!d.data.registered) return mem(code, info)
  const l = d.data.user.learningtasks || []

  const n = l.n(e => e.tempCode == code, 1)
  if (n == -1) return mem(code, info)

  const id = l[n].id

  const day = u.tm().t(0, 10).e('-', '')
  const r = await u.get(`/mopa/api-internet-user/open/learningschedule/get-by-day/${appid}/${openid}/${day}`, {day})
  const ll = r.data || []
  if (ll.n(e => e.taskId == id || (e.tempCode && e.tempCode == code), 1) > -1) return  // finish task return

  if (!st) return
  await u.fet(`/mopa/api-internet-user/open/learningschedule/finish-by-id/${id}`)
}

u.rs = {}
u.rs.todotip = chk
